import { Component, Input, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormControl, ReactiveFormsModule } from '@angular/forms';
import { DropdownOptionComponent, DropdownOption } from '@shared/components/ui/dropdown/dropdown-option.component';

@Component({
  selector: 'app-dcf-common-dropdown',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, DropdownOptionComponent],
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => DcfCommonDropdownComponent), multi: true }],
  template: `
    <div>
      <label *ngIf="fieldSchema?.label" class="block text-sm font-medium text-gray-700 mb-1">
        {{ fieldSchema.label }}
      </label>
      <app-dropdown-option
        [options]="dropdownOptions"
        [placeholder]="fieldSchema?.placeholder || 'Select an option'"
        [value]="value"
        [disabled]="disabled"
        (valueChange)="onDropdownChange($event)">
      </app-dropdown-option>
    </div>
  `
})
export class DcfCommonDropdownComponent implements ControlValueAccessor {
  @Input() fieldSchema: any;
  @Input() formControl!: FormControl;

  value: any = null;
  disabled: boolean = false;

  private onChange: (value: any) => void = () => {};
  private onTouched: () => void = () => {};

  get dropdownOptions(): DropdownOption[] {
    if (!this.fieldSchema?.options) return [];
    return this.fieldSchema.options.map((opt: any) => ({
      value: opt.value,
      label: opt.label,
      disabled: opt.disabled || false
    }));
  }

  onDropdownChange(value: any): void {
    this.value = value;
    this.onChange(value);
    this.onTouched();
  }

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: (value: any) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
